import { z } from 'zod';

/**
 * "Este voucher é de um pedido do MICE?" (`GET /internal/voucher-purchase` do mice-api, lido
 * pelo voucher-events). O legado só carimba `isEvent` quando o cliente da reserva é workspace de
 * evento; um projeto MICE que compra num cliente comum gera um voucher igual a uma compra da
 * plataforma, e só o mice-api sabe que é dele. Casa pelo id (gravado quando o acompanhamento liga
 * o voucher ao pedido) ou pela chave do checkout (`correlationId`, gravada antes do booking: já
 * vale no `voucher.created`).
 */
export const MiceVoucherPurchaseQuerySchema = z.object({
  voucherId: z.string().min(1),
  correlationId: z.string().min(1).optional(),
});
export type MiceVoucherPurchaseQuery = z.infer<typeof MiceVoucherPurchaseQuerySchema>;

export const MiceVoucherPurchaseResponseSchema = z.object({ micePurchase: z.boolean() });
export type MiceVoucherPurchaseResponse = z.infer<typeof MiceVoucherPurchaseResponseSchema>;
